export default class Modal {
    static getInstance(querySelector) {
        const modalElement = document.querySelector(querySelector);
        return bootstrap.Modal.getOrCreateInstance(modalElement);
    }

    static toggle(querySelector) {
        try {
            const modalInstance = this.getInstance(querySelector);
            modalInstance.toggle();
        } catch (e) {
            console.log(e)
        }
    }

    static hide(querySelector) {
        try {
            const el = document.querySelector(querySelector);
            const instance = el ? bootstrap.Modal.getInstance(el) : null;
            if (instance) instance.hide();
        } catch (e) {
            console.log(e)
        }
    }

    static onShow(querySelector, callback) {
        const modalElement = document.querySelector(querySelector);
        modalElement.addEventListener('shown.bs.modal', callback);
    }

    static onClose(querySelector, callback) {
        const modalElement = document.querySelector(querySelector);
        modalElement.addEventListener('hide.bs.modal', callback);
    }

    static onAfterClose(querySelector, callback) {
        const modalElement = document.querySelector(querySelector);
        modalElement.addEventListener('hidden.bs.modal', callback);
    }

}